import { defineComponent } from '@nuxtjs/composition-api';
import { EDIT_SECTION_EVENT_NAME } from '@/components/partials/public-portfolio/constants';

export default defineComponent({
  methods: {
    onEditSection(section: string, modalName: string) {
      this.$analytics.logEvent(EDIT_SECTION_EVENT_NAME, {
        name: section,
      });
      this.$router.push(`?dynamic_modal=${modalName}`);
    },

    onAddToSection(section: string, modalName: string) {
      this.$analytics.logEvent('public-portfolio__add-to-section', {
        name: section,
      });
      this.$router.push(`?dynamic_modal=${modalName}`);
    },

    onTipClick(section: string) {
      this.$analytics.logEvent('public-portfolio__tip', {
        name: section,
      });
    },
  },
});
